import React from 'react';

import { isEmpty } from 'lodash';

import { Model } from '../../../store/types';
import { ContainersCell } from './ContainersCell';
import { MPNCell } from './MPNCell';
import { OrderID, OrderLineItemNumber } from './OrderDefs';
import { ExpectedReceivedQuanityCell, ReceivingQuanityCell, RemainingQuanityCell } from './Quantities';

// const AsnTypes = [ReceiveType.ASN_JANUS, ReceiveType.ASN_OMD, ReceiveType.ASN_RMA, ReceiveType.ASN_WW_FA, ReceiveType.ASN_AWS_OWNED_INVENTORY_RO];
// const isASNType = (orderType: ReceiveType) => AsnTypes.includes(orderType);

const Definitions = [
  {
    id: 'mpnipnid',
    header: 'MPN + IPN ID',
    cell: (model: Model) => {
      return model.mpnIpnId;
    },
  },
  {
    id: 'mpn',
    header: 'Manufactured Part Number (MPN)',
    cell: (model: Model) => {
      return <MPNCell model={model} />;
    },
    minWidth: 275,
  },
  {
    id: 'manufacturer',
    header: 'Manufacturer',
    cell: (model: Model) => {
      return model?.manufacturer;
    },
    minWidth: 275,
  },
  {
    id: 'apn',
    header: 'Amazon part number (APN/IPN)',
    cell: (model: Model) => model?.mappedIPN,
    minWidth: 275,
  },
  {
    id: 'apn_desc',
    header: '(APN/IPN) Description',
    cell: (model: Model) => model?.description,
    minWidth: 250,
  },
  {
    id: 'buildCategory',
    header: 'Category',
    cell: (model: Model) => {
      return model?.buildCategory;
    },
    minWidth: 130,
  },
  {
    id: 'expectedAndReceivedQty',
    header: 'Received Qty/Expected Qty.',
    cell: (model: Model) => <ExpectedReceivedQuanityCell model={model} />,
    minWidth: 200,
  },
  {
    id: 'remainingQuantity',
    header: 'Remaining Qty',
    cell: (model: Model) => <RemainingQuanityCell model={model} />,
    minWidth: 170,
  },
  {
    id: 'received',
    header: 'Receiving Qty',
    cell: (model: Model) => {
      return <ReceivingQuanityCell model={model} />;
    },
    minWidth: 140,
  },
  {
    id: 'containers',
    header: 'Containers',
    cell: (model: Model) => {
      return <ContainersCell model={model} />;
    },
    minWidth: 280,
  },
  {
    id: 'build_id',
    header: 'Build ID',
    cell: (model: Model) => (isEmpty(model?.buildId) ? 'NA' : model?.buildId),
    minWidth: 120,
  },
  {
    id: 'orderLineItemNumber',
    header: 'Order Line Item Number',
    cell: (model: Model) => <OrderLineItemNumber model={model} />,
    minWidth: 220,
  },
  {
    id: 'orderID',
    header: 'Order Number',
    cell: (model: Model) => <OrderID model={model} />,
    minWidth: 170,
  },
  {
    id: 'status',
    header: 'Status',
    cell: (model: Model) => model?.status,
  },
];

const DefinitionsForIA = [
  {
    id: 'mpnipnid',
    header: 'MPN + IPN ID',
    cell: (model: Model) => {
      return model.mpnIpnId;
    },
  },
  {
    id: 'mpn',
    header: 'Manufactured Part Number (MPN)',
    cell: (model: Model) => {
      return <MPNCell model={model} />;
    },
    minWidth: 275,
  },
  {
    id: 'manufacturer',
    header: 'Manufacturer',
    cell: (model: Model) => model?.manufacturer,
    minWidth: 275,
  },
  {
    id: 'apn',
    header: 'Amazon part number (APN/IPN)',
    cell: (model: Model) => model?.mappedIPN,
    minWidth: 275,
  },
  {
    id: 'reason',
    header: 'Receive Reason',
    cell: (model: Model) => model?.receiveReason,
    minWidth: 275,
  },
  {
    id: 'apn_desc',
    header: '(APN/IPN) Description',
    cell: (model: Model) => model?.description,
    minWidth: 250,
  },
  {
    id: 'buildCategory',
    header: 'Category',
    cell: (model: Model) => model?.buildCategory,
    minWidth: 130,
  },
  {
    id: 'received',
    header: 'Receiving Qty',
    cell: (model: Model) => {
      return <ReceivingQuanityCell model={model} />;
    },
    minWidth: 140,
  },
  {
    id: 'containers',
    header: 'Containers',
    cell: (model: Model) => {
      return <ContainersCell model={model} />;
    },
    minWidth: 280,
  },
  {
    id: 'build_id',
    header: 'Build ID',
    cell: (model: Model) => (isEmpty(model?.buildId) ? 'NA' : model?.buildId),
    minWidth: 120,
  },
  {
    id: 'status',
    header: 'Status',
    cell: (model: Model) => model?.status,
  },
];

export const visibleColumns = [
  'mpn',
  'reason',
  'buildCategory',
  'po',
  'expectedAndReceivedQty',
  'received',
  'containers',
];
const modelProperties = [
  {
    id: 'mpn',
    label: 'Manufactured part number (MPN)',
    alwaysVisible: true,
  },
  {
    id: 'apn',
    label: 'Amazon part number (APN/IPN)',
  },
  { id: 'apn_desc', label: '(APN/IPN) Description' },
  { id: 'buildCategory', label: 'Category' },
  { id: 'manufacturer', label: 'Manufacturer' },

  {
    id: 'expectedAndReceivedQty',
    label: 'Received Qty/Expected Qty.',
  },
  {
    id: 'remainingQuantity',
    label: 'Remaining Qty',
  },
  {
    id: 'received',
    label: 'Quantity received',
  },
  {
    id: 'containers',
    label: 'Containers',
  },
  {
    id: 'build_id',
    label: 'Build ID',
  },
  {
    id: 'orderLineItemNumber',
    label: 'Order Line Item Number',
  },
  {
    id: 'orderID',
    label: 'Order Number',
  },
];
export const contentDisplayPrefernece = {
  label: 'MPN properties',
  options: modelProperties,
};
export const contentDisplay = modelProperties.map(({ id }) => ({
  id,
  visible: !!visibleColumns.find((c) => c === id),
}));

export const visibleContentPreference = {
  title: 'Select visible content',
  options: [contentDisplayPrefernece],
};

const DefinitionsObject = {
  Definitions,
  DefinitionsForIA,
  DefinitionsForRMA: Definitions.filter((d) => {
    return d?.id !== 'expectedAndReceivedQty' && d?.id !== 'remainingQuantity';
  }),
};

export default DefinitionsObject;
